import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-[#E8EDDF] py-4 md:py-8" data-id="element-109">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-110">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white border border-[#E8D5BA] rounded-lg p-4 md:p-8 text-center shadow-sm" data-id="element-111">
          <div className="flex justify-center mb-2 md:mb-3" data-id="element-112">
            <div className="bg-[#7A9471]/10 p-3 rounded-full" data-id="element-113">
              <ShieldIcon className="w-10 h-10 text-[#7A9471]" data-id="element-114" />
            </div>
          </div>

          <h2 className="text-2xl md:text-3xl font-bold text-[#3D2817] mb-2 md:mb-3" data-id="element-115">
            🛡️ GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>

          <p className="text-base text-[#6B5747] mb-2 md:mb-3 leading-relaxed" data-id="element-116">
            Abrís los tomos. Probás las recetas. Aplicás las técnicas. Si en 7
            días no es lo que esperabas: devolución del 100% — sin formularios,
            sin drama, sin explicaciones.
            <br data-id="element-117" />
            <br data-id="element-118" />
            Confiamos en el producto. Por eso damos la garantía sin dudar.
          </p>

          <p className="text-lg font-bold text-[#B45309]" data-id="element-119">
            Tasa de devoluciones: menos del 1%.
          </p>
        </motion.div>
      </div>
    </section>;
}